<template>
<div class="color-input d-f">
  <div class="color d-f">
    <div :class="`color-box ${!useAlpha ? 'remove-alpha' : ''} ${noInput ? 'rounded' : ''}`" :style="`background-color: ${color}`" @click="open">
      <ColorPicker :value="color" v-if="opened" @input="colorPickerInput" v-click-outside="close" />
    </div>
    <FormInput class="" :value="hex" @input="inputValue('hex', $event)" v-if="!noInput" />
  </div>
  <FormInput class="alpha center-text" :stepper="true" type="number" :step="1" :min="0" :max="100" :value="Math.round(alpha * 100)" @input="inputValue('alpha', $event / 100)" fixedPlaceholder="%" v-if="useAlpha && !hideAlpha" />
</div>
</template>

<script>
import validateColor from 'validate-color';
// eslint-disable-next-line
import ChromePicker from 'vue-color/src/components/Chrome';

export default {
  props: {
    value: {
      type: String,
      default: '#FFFFFF',
    },
    noalpha: {
      type: Boolean,
      default: false,
    },
    hideAlpha: {
      type: Boolean,
      default: false,
    },
    returnRGB: {
      type: Boolean,
      default: false,
    },
    noInput: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ColorPicker: ChromePicker,
  },
  methods: {
    colorPickerInput(ev) {
      this.hex = ev.hex;
      this.alpha = Math.round(ev.a * 100) / 100;
      this.rgb = `${ev.rgba.r},${ev.rgba.g},${ev.rgba.b}`;

      this.emit();
    },
    inputValue(type, value) {
      this[type] = value;
      this.emit();
    },
    close() {
      this.opened = false;
    },
    open() {
      setTimeout(() => {
        this.opened = true;
      }, 100);
    },
    emit() {
      if (this.returnRGB) {
        this.color = this.hex;
        this.$emit('color', this.rgb);
        return;
      }

      const color = `${this.hex}${this.convertAlpha(this.alpha)}`;
      if (validateColor(color)) {
        this.color = color;
        this.$emit('color', color);
      }
    },
    /**
     * Convert alpha to hex, eg 0.5 => 80.
     * @param {Float} alpha
     * @returns {String}
     */
    convertAlpha(alpha) {
      return `${alpha}` === '0' || `${alpha}` === '00' || `${alpha}` === '0,0' || `${alpha}` === '0.0' ? '00' : Math.round(Math.min(Math.max(alpha || 1, 0), 1) * 255).toString(16).toUpperCase();
    },
    toHex8() {
      return `${this.hex}${this.convertAlpha(this.alpha)}`;
    },
    hexAtoFloat(hex) {
      return Math.round(+(`0x${hex[7]}${hex[8]}` / 255) * 100) / 100;
    },
    componentToHex(c) {
      const hex = c.toString(16);
      return hex.length === 1 ? `0${hex}` : hex;
    },
    rgbToHex(r, g, b) {
      return `#${this.componentToHex(r)}${this.componentToHex(g)}${this.componentToHex(b)}`;
    },
  },
  data() {
    return {
      hex: '#FFFFFF',
      rgb: '',
      alpha: 1,
      color: '',
      opened: false,
      useAlpha: false,
    };
  },
  mounted() {
    if (this.value) {
      if ((this.value.match(/,/g) || []).length === 2) {
        const rgb = this.value.split(',');
        this.color = this.rgbToHex(parseInt(rgb[0], 10), parseInt(rgb[1], 10), parseInt(rgb[2], 10));
        this.hex = this.color;
      } else {
        this.hex = this.value.substring(0, 7);

        if (this.value.length === 9 && !this.noalpha) {
          this.useAlpha = true;
          this.alpha = this.hexAtoFloat(this.value);
        }

        this.color = this.noalpha ? this.hex : this.value;
      }
    }
  },
};
</script>

<style lang="scss">
.color-box {
  border: 1px solid #B7BDC6;
  cursor: pointer;
  width: 42px;
  height: 42px;
  position: relative;

  &.rounded {
    border-radius: 7px;
  }

  .vc-chrome {
    position: absolute;
    left: 50%;
    top: 70%;
    z-index: 1;
    transform: translateX(-50%);
  }

  &.remove-alpha {
    .vc-chrome-alpha-wrap {
      display: none;
    }
    .vc-chrome-hue-wrap {
      margin-top: 9px;
    }
  }
}

.color-input {
  .input {
    input {
      min-height: 27px;
      font: 12px/18px 'Fira Mono', monospace;
      padding: 11px 10px;
      font-size: 16px;
    }
  }
  .color {
    .input {
      width: 100px;
    }
  }

  .alpha {
    margin-left: 10px;
  }
}
</style>
